export const COURSE_FILTERS = Object.freeze({
  FEATURED: 'Featured',
  LIVE: 'Live',
  ON_DEMAND: 'OnDemand',
  TUTORIALS: 'Tutorials',
  REGISTERED_COURSES: 'RegisteredCourses',
  INTRO: '2-HourCourse',
  COMPLIANCE_CONNECTIONS: 'ComplianceConnections',
  SLA_UNIVERSITY: 'SLAUniversity'  
});